import React from "react";
import { theme, Heading1 } from "@ovotech/element";

interface SplitHeadingProps {
  part1: string;
  part2: string;
  part1Color?: string;
  part2Color?: string;
}

export const SplitHeading: React.FC<SplitHeadingProps> = ({
  part1,
  part2,
  part1Color = "#00261c", // Default color for part1
  part2Color = "#0a9828", // Default color for part2
}) => {
  return (
    <Heading1 className={"SplitHeading"}>
      <span
        style={{
          fontWeight: theme.font.weight.black,
          color: part1Color,
        }}
      >
        {part1}
      </span>
      <span
        style={{
          fontWeight: theme.font.weight.black,
          color: part2Color,
        }}
      >
        {/* Adding a space before part2 if it doesn't start with one */}
        {part2.startsWith(" ") ? part2 : ` ${part2}`}.
      </span>
    </Heading1>
  );
};
